<template>
    <el-input type="tel"
              v-bind="$attrs"
              pattern="\+7\s(\d{3}\s){2}(\d{2}\s?){2}"
              v-mask="'+7 ### ### ## ##'"
              :placeholder="placeholder"
              v-model="phone"
              :dusk="dusk"
              @focus="$emit('focus', $event)"
              @input="checkAndCleanEight($event)"/>
</template>

<script>
import {mask} from "vue-the-mask";

export default {
    name: "InputPhone",
    directives: {mask},
    props: {
        value: {
            type: String,
            requested: true
        },
        placeholder: {
            type: String,
            default: '+7 999 999 99 99'
        },
        dusk: {
            type:String,
            default: 'phone'
        }
    },
    data: () => ({
        phone: '',
        regexForEight: new RegExp('^\\+?8')
    }),
    watch: {
        value(val) {
            this.phone = val;
        },
        phone(val) {
            this.$emit('input', val);
        }
    },
    methods: {
        checkAndCleanEight(val) {
            if (this.regexForEight.test(val)) {
                this.$nextTick(() => {
                   this.phone = '+7';
                });
            }
        },
    },
    mounted() {
        this.phone = this.value;
    }
}
</script>
